import { CalendarSearch } from 'lucide-react'
import { useState } from 'react'
import { useBrand } from 'hooks/useBrand'
import { useScheduling } from 'hooks/useScheduling'
import When from 'utils/when'
import FindAppointmentModal from './FindAppointmentModal'
import LoginForm from './LoginForm'
import LoginFormAspaec from './LoginFormAspaec'
import SimplifiedRegisterForm from './SimplifiedRegisterForm'
import { ActionButton, Container, FormHeader } from './styles'

export default function IdentificationStep() {
  const { checkoutFormState, setCheckoutFormState } = useScheduling()
  const { brand, config } = useBrand()
  const [showFindAppointment, setShowFindAppointment] = useState(false)
  // "Já tenho uma consulta" (ex. Vikura): busca a última consulta por
  // email + CPF para mostrar horário e link, sem precisar entrar no funil.
  const hasAppointmentLookup = config.scheduling.hasAppointmentLookup === true
  const isAspaec = brand === 'aspaec'
  // Marcas whitelabel (Aspaec, Remederi, Vikura) não oferecem login no
  // agendamento — o paciente sempre se cadastra. Só Cannect tem "Entrar".
  const allowLogin = brand === 'cannect'
  const isBranded = brand !== 'cannect'

  return (
    <Container isBranded={isBranded}>
      <FormHeader>
        <h3>Dados do paciente</h3>
        <When expr={allowLogin && checkoutFormState === 'simplified'}>
          <ActionButton className="login-button" type="button" onClick={() => setCheckoutFormState('login')}>
            Entrar
          </ActionButton>
        </When>
        <When expr={allowLogin && checkoutFormState === 'login'}>
          <ActionButton className="login-button" type="button" onClick={() => setCheckoutFormState('simplified')}>
            Cadastre-se
          </ActionButton>
        </When>
      </FormHeader>
      {isBranded && (
        <p className="w-full text-sm text-gray-500">Para dar início a sua jornada, preencha os dados abaixo:</p>
      )}
      {(checkoutFormState === 'simplified' || !allowLogin) && <SimplifiedRegisterForm />}
      {allowLogin && checkoutFormState === 'login' && (isAspaec ? <LoginFormAspaec /> : <LoginForm />)}
      {hasAppointmentLookup && (
        <button
          type="button"
          onClick={() => setShowFindAppointment(true)}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg border border-solid border-gray-200 bg-white py-3 text-sm font-semibold text-primary-700 shadow-sm transition-colors hover:border-gray-400">
          <CalendarSearch className="size-4" />
          Já tenho uma consulta agendada
        </button>
      )}
      {showFindAppointment && <FindAppointmentModal onClose={() => setShowFindAppointment(false)} />}
    </Container>
  )
}
